import { render, staticRenderFns } from "./IrisAccount.vue?vue&type=template&id=6990c818&"
import script from "./IrisAccount.vue?vue&type=script&lang=ts&"
export * from "./IrisAccount.vue?vue&type=script&lang=ts&"
import style0 from "./IrisAccount.vue?vue&type=style&index=0&id=6990c818&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports